module.exports = __webpack_public_path__ + "static/invisible_stalker-ca64d286d714c96a0a6a9e092a479d99.jpeg";